import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {PermissionConfigModel} from './permission-config.model';
import {environment} from '../../../environments/environment';
import {map, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionConfigService {

  constructor(
    private http: HttpClient
  ) {
  }

  public getPermissionConfigForCalculatedRole(calculatedRole: string): Observable<PermissionConfigModel> {
    const params = (new HttpParams())
      .append('PermissionConfigSearch[calculatedRole]', calculatedRole);
    return this.http.get<PermissionConfigModel[]>(
      environment.apiBasepoint + 'permission-config',
      {observe: 'body', params: params}
    ).pipe(
      map(
        models => models[0]
      )
    );
  }

  public getPermissionConfigForUser(
    role: string,
    userCreatorId: number | null,
    customRoleId: number | null
  ): Observable<PermissionConfigModel> {
    let params = (new HttpParams())
      .append('PermissionConfigSearch[role]', role);
    if (userCreatorId) {
      params = params.append('PermissionConfigSearch[userCreatorId]', userCreatorId.toString());
    }
    if (customRoleId) {
      params = params.append('PermissionConfigSearch[customRoleId]', customRoleId.toString());
    }
    return this.http.get<PermissionConfigModel[]>(
      environment.apiBasepoint + 'permission-config',
      {observe: 'body', params: params}
    ).pipe(
      map(
        models => models[0]
      )
    );
  }
}
